import { Outlet } from 'react-router-dom';

const PrivateRoutes = () => {
  let auth = !!localStorage.getItem('token');
  let role = localStorage.getItem('role');
  const isAdmin = JSON.parse(localStorage.getItem('isAdmin'));
  const navigate = () => {
    window.location.href = isAdmin ? '/managementLogin' : '/donorLogin';
  };

  return auth ? <Outlet /> : navigate();
};

export default PrivateRoutes;
